import { render, staticRenderFns } from "./historyComment.vue?vue&type=template&id=36cc1098&scoped=true&"
import script from "./historyComment.vue?vue&type=script&lang=js&"
export * from "./historyComment.vue?vue&type=script&lang=js&"
import style0 from "./historyComment.vue?vue&type=style&index=0&id=36cc1098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc1098",
  null
  
)

export default component.exports